export default __webpack_public_path__ + "static/media/43_the_hat.75389a69.png";